import * as React from 'react'

import { cn } from '@/customer/lib/utils'

/**
 * Multi-line text input. Matches the chunky h-12 / border-2 look of the
 * customer `Input`. Uses `field-sizing: content` so the textarea grows with
 * its content up to `min-h-24`.
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content min-h-24 w-full rounded-lg border-2 border-input bg-background px-4 py-3 text-body-md transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/30',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
